/*
 * @Author: wangjing 175523310@qq.com
 * @Date: 2022-08-23 08:46:58
 * @LastEditors: wangjing 175523310@qq.com
 * @LastEditTime: 2022-08-23 16:46:54
 * @FilePath: \m-mall-dc\src\api\recommendBrand.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { request } from "@/utils/request";

// 获取购物车列表
export const getAllList = (data) => {
  return request({
    url: "/product/public/homeLayout/getAllList",
    method: "GET",
    data: data,
  });
};

// 获取专区头图
export const getSpecialAreaPic = (param) => {
  return request({
    url: "/product/public/mall/area/queryAreaById",
    method: "POST",
    data: param,
  });
};

// 跳转专区
export const querySpecialArea = (param) => {
  return request({
    url: "/product/public/mall/area/selectAreaProductByAreaId",
    method: "POST",
    data: param,
  });
};

// 获取首页Banner图片
export const getIndexImgList = (params) => {
  return request({
    url: "/cms/public/cmsMap/queryMainBanner",
    method: "GET",
    data: params,
  });
};

// 获取首页推荐商品 的所属公司
export const getProductCompany = (data) => {
  return request({
    url: "/product/public/getProductCompany",
    method: "POST",
    data: data,
  });
};

// 获取楼层信息
export const queryFloorByAreaIdForMobile = (params) => {
  return request({
    url: "/product/public/homeLayout/queryFloorByAreaIdForMobile",
    method: "POST",
    data: params,
  });
};

// 获取8号楼层商品列表
export const queryHomeLayoutProductByPageForFloor = (params) => {
  return request({
    url: "/product/public/queryHomeLayoutProductByPageForFloor",
    method: "POST",
    data: params,
  });
};
